import React, { createContext, useContext, useState, useCallback } from "react";
import { isEqual, isFunction } from "lodash";
import { initialFilter } from "./UserUIHelpers";

const UserUIContext = createContext();

export function useUserUIContext() {
  return useContext(UserUIContext);
}

export const UserUIConsumer = UserUIContext.Consumer;

export function UserUIProvider({
  userUIEvents,
  children,
  queryParams,
  setQueryParamsBase,
  ids,
  setIds,
}) {
  const setQueryParams = useCallback((nextQueryParams) => {
    setQueryParamsBase((prevQueryParams) => {
      if (isFunction(nextQueryParams)) {
        nextQueryParams = nextQueryParams(prevQueryParams);
      }

      if (isEqual(prevQueryParams, nextQueryParams)) {
        return prevQueryParams;
      }

      return nextQueryParams;
    });
  }, []);

  const value = {
    queryParams,
    setQueryParamsBase,
    ids,
    setIds,
    setQueryParams,
    openReceiptDialog: userUIEvents.openReceiptDialog,
    openEditStatusDialog: userUIEvents.openEditStatusDialog,
  };

  return (
    <UserUIContext.Provider value={value}>{children}</UserUIContext.Provider>
  );
}
